import React, { Component } from "react";
import { subscribeToLoading } from "../../Api/loadingTracker";

// Waits briefly before showing so fast requests don't flash the spinner.
const SHOW_DELAY_MS = 150;

class GlobalLoader extends Component {
    state = { visible: false };

    componentDidMount() {
        this.unsubscribe = subscribeToLoading(isLoading => {
            clearTimeout(this.showTimer);
            if (isLoading) {
                this.showTimer = setTimeout(() => this.setState({ visible: true }), SHOW_DELAY_MS);
            } else {
                this.setState({ visible: false });
            }
        });
    }

    componentWillUnmount() {
        clearTimeout(this.showTimer);
        this.unsubscribe();
    }

    render() {
        if (!this.state.visible) {
            return null;
        }
        return (
            <div className="global-loader" role="status" aria-live="polite">
                <div className="global-loader-spinner" />
                <span className="global-loader-label">Loading…</span>
            </div>
        );
    }
}

export default GlobalLoader;
